import { GridHeaderCellProps } from '@progress/kendo-react-grid/dist/npm/interfaces/GridHeaderCellProps';
import { useMemo } from 'react';
import { GridColumn } from 'src/components/GridWrapper';
import useViewDepartment from 'src/hooks/useViewDepartments';
import RenameDepartmentCell from 'src/sections/view_department/view_department_cell/RenameDepartmentCell';
import DepartmentEdit from './DepartmentEdit';
import DepartmentGLCodes from './DepartmentGLCodes';
import DepartmentMembers from './DepartmentMembers';

const headerCell = (props: GridHeaderCellProps) => <div className="m-auto">{props.title}</div>;

export const useDepartmentColumn = () => {
  const { hasEditDepartmentPermission, t } = useViewDepartment();
  const viewDepartmentColumns: GridColumn<any>[] = useMemo(
    () => [
      ...(hasEditDepartmentPermission
        ? ([
            {
              field: 'selected',
              title: '',
              className: 'text-center',
              filter: 'boolean',
              menu: false,
              dataType: 'fixed',
              sortable: false,
            },
          ] as const)
        : []),
      {
        field: 'name',
        title: t('Department Name'),
        component: RenameDepartmentCell,
        filter: 'text',
      },
      {
        field: 'glCodes',
        title: t('Department GL Codes'),
        component: DepartmentGLCodes,
        headerCell: headerCell,
        menu: false,
        sortable: false,
      },
      {
        field: 'members',
        title: t('Department Members'),
        component: DepartmentMembers,
        headerCell: headerCell,
        menu: false,
        sortable: false,
      },
      ...(hasEditDepartmentPermission
        ? ([
            {
              field: 'canEdit',
              title: t('Department GL Codes/Members'),
              component: DepartmentEdit,
              headerCell: headerCell,
              menu: false,
              sortable: false,
            },
          ] as const)
        : []),
    ],
    [hasEditDepartmentPermission, t]
  );
  return viewDepartmentColumns;
};
